import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import { News } from "@/models";

const state = {
  news: [],
  newsLoading: false,
  singleNews: new News(),
  singleNewsLoading: false,
  categories: [],
  categoriesLoading: false,
  tags: [],
  tagsLoading: false,
  meta: {},
  latestNews: [],
  latestNewsLoading: false
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
